import { useCallback, useState, useMemo } from 'react';
import { debounce } from 'underscore';
import EPSurveyThumbFeedback from './EPSurveyThumbFeedback';
import EPSurveyForm from './EPSurveyForm';
import EPSurveyThankyouContainer from './EPSurveyThankyouContainer';
import styled from 'styled-components';

// @ts-expect-error not typed yet
import { CSSTransitionGroup } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SurveyWrapper = styled.div.withConfig({
  displayName: "EPSurvey__SurveyWrapper",
  componentId: "sc-1cuvvat-0"
})([".fade-enter{opacity:0;}.fade-enter-active{opacity:1;transition:opacity 2000ms;}.fade-exit{opacity:1;}.fade-exit-active{opacity:0;transition:opacity 2000ms;}"]);
const FEEDBACK_BUTTON_STATES = {
  FEEDBACK: 'FEEDBACK',
  SUBMITTED: 'SUBMITTED'
};
const EPSurvey = ({
  closeFeedbackBadge,
  setFeedbackAsSubmitted,
  handleTracking,
  mainTitle,
  formTitle
}) => {
  const [feedbackButtonState, setFeedbackButtonState] = useState(undefined);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const trackFeedback = useCallback(isPositive => {
    const feedbackObj = {
      isPositive,
      feedbackMessage
    };
    handleTracking(feedbackObj);
  }, [feedbackMessage, handleTracking]);
  const updateFeedbackMessage = useMemo(() => debounce(e => {
    setFeedbackMessage(e.target.value);
  }, 200), []);
  const updateIsPositiveFeedback = useCallback(isPositive => {
    setFeedbackButtonState(FEEDBACK_BUTTON_STATES.FEEDBACK);
    trackFeedback(isPositive);
    setFeedbackAsSubmitted();
  }, [trackFeedback, setFeedbackAsSubmitted]);
  const submitFeedback = () => {
    setFeedbackMessage(feedbackMessage);
    setFeedbackButtonState(FEEDBACK_BUTTON_STATES.SUBMITTED);
    trackFeedback();
    setFeedbackAsSubmitted();
  };
  return /*#__PURE__*/_jsx(SurveyWrapper, {
    children: /*#__PURE__*/_jsxs(CSSTransitionGroup, {
      transitionName: "fade",
      transitionEnterTimeout: 600,
      transitionLeaveTimeout: 400,
      children: [!feedbackButtonState && /*#__PURE__*/_jsx(EPSurveyThumbFeedback, {
        closeFeedbackBadge: closeFeedbackBadge,
        updateIsPositiveFeedback: updateIsPositiveFeedback,
        title: mainTitle
      }), feedbackButtonState === FEEDBACK_BUTTON_STATES.FEEDBACK && /*#__PURE__*/_jsx(EPSurveyForm, {
        closeFeedbackBadge: closeFeedbackBadge,
        updateFeedbackMessage: updateFeedbackMessage,
        feedbackMessage: feedbackMessage,
        submitFeedback: submitFeedback,
        title: formTitle
      }), feedbackButtonState === FEEDBACK_BUTTON_STATES.SUBMITTED && /*#__PURE__*/_jsx(EPSurveyThankyouContainer, {
        closeFeedbackBadge: closeFeedbackBadge
      })]
    })
  });
};
export default EPSurvey;